import { DBMS_STATUS, type DbmsInfo } from '@nx/state/desktop';

export const getOnlineStatusColor = (instance: DbmsInfo) => {
  switch (instance.status) {
    case DBMS_STATUS.STARTED:
      return 'success';
    default:
      return 'default';
  }
};
